<template>
  <v-container fluid fill-height>
    <v-layout>
      <v-flex xs12 sm12 md12>
        <v-card class="rounded-lg">
          <v-toolbar color="#f8f9fb" elevation="0">
            <v-toolbar-title>{{
              `${this.$t("event.edit.title")}`
            }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn class="primary" @click="$router.go(-1)">
              <v-icon left> mdi-chevron-double-left </v-icon>
              {{ `${this.$t("event.edit.buttons.back")}` }}
            </v-btn>
          </v-toolbar>
          <v-divider></v-divider>
          <v-card-text class="pa-10">
            <v-form>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="6" class="">
                  <input
                    type="file"
                    name="profile_pic"
                    @change="changeFile($event)"
                    ref="profile_pic"
                    hidden
                  />
                  <v-badge bordered bottom overlap offset-x="20" offset-y="20">
                    <template v-slot:badge>
                      <v-icon
                        small
                        dark
                        @click="openFileExplorer"
                        class="edit-icon"
                      >
                        mdi-pencil
                      </v-icon>
                    </template>
                    <v-avatar
                      size="120"
                      v-if="event.picture_url != null"
                      class="cursor-pointer imagePreviewWrapper"
                      @click="openFileExplorer"
                    >
                      <img
                        :src="API_BASE_URL + '/uploads/' + event.picture_url"
                        :alt="event.picture_url"
                        v-if="!previewImage"
                      />
                      <img
                        :src="previewImage"
                        :alt="event.picture_url"
                        v-if="previewImage"
                      />
                    </v-avatar>
                    <v-avatar
                      v-if="event.picture_url == null"
                      color="secondary"
                      class="white--text cursor-pointer imagePreviewWrapper"
                      :style="{ 'background-image': `url(${previewImage})` }"
                      size="120"
                      @click="openFileExplorer"
                    >
                    </v-avatar>
                  </v-badge>
                </v-col>
              </v-row>
              <span :class="`${serverSideErrors.picture ? 'red--text' : 'grey--text'}`" :style="{ marginBottom: '10px' }">
                {{ serverSideErrors.picture ? serverSideErrors.picture : "Only jpg, png, gif are allowed" }}
              </span>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="6">
                  <v-text-field
                    v-model="event.title"
                    name="title"
                    label="Title"
                    v-validate="'required'"
                    :error="
                      errors.first('title') != null ||
                      serverSideErrors.title != null
                    "
                    :error-messages="
                      errors.first('title') || serverSideErrors.title
                    "
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="6">
                  <v-textarea
                    v-model="event.description"
                    name="description"
                    label="Description"
                    rows='1'
                    v-validate="'required'"
                    :error="
                      errors.first('description') != null ||
                      serverSideErrors.description != null
                    "
                    :error-messages="
                      errors.first('description') ||
                      serverSideErrors.description
                    "
                  ></v-textarea>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="6">
                  <v-datetime-picker
                    label="Start Date"
                    id="start_datetime"
                    name="start_datetime"
                    data-vv-as="Start date-time"
                    clearable
                    dateFormat="dd-MM-yyyy"
                    timeFormat="hh:mm a"
                    v-model="event.start_datetime"
                    v-validate="'required'"
                    :error="
                      errors.first('start_datetime') != null ||
                      serverSideErrors.start_datetime != null
                    "
                    :error-messages="
                      errors.first('start_datetime') ||
                      serverSideErrors.start_datetime
                    "
                  >
                    <template slot="dateIcon">
                      <v-icon>mdi-calendar</v-icon>
                    </template>
                    <template slot="timeIcon">
                      <v-icon>mdi-clock-outline</v-icon>
                    </template>
                  </v-datetime-picker>
                  <span
                    class="red--text"
                    v-if="
                      errors.first('start_datetime') ||
                      serverSideErrors.start_datetime
                    "
                  >
                    {{
                      errors.first("start_datetime") ||
                      serverSideErrors.start_datetime
                    }}
                  </span>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="6">
                  <v-datetime-picker
                    label="End Date"
                    id="end_datetime"
                    name="end_datetime"
                    data-vv-as="End date-time"
                    clearable
                    dateFormat="dd-MM-yyyy"
                    timeFormat="hh:mm a"
                    v-validate="'required'"
                    v-model="event.end_datetime"
                    :error="
                      errors.first('end_datetime') != null ||
                      serverSideErrors.end_datetime != null
                    "
                    :error-messages="
                      errors.first('end_datetime') ||
                      serverSideErrors.end_datetime
                    "
                  >
                    <template slot="dateIcon">
                      <v-icon>mdi-calendar</v-icon>
                    </template>
                    <template slot="timeIcon">
                      <v-icon>mdi-clock-outline</v-icon>
                    </template>
                  </v-datetime-picker>
                  <span
                    class="red--text"
                    v-if="
                      errors.first('end_datetime') ||
                      serverSideErrors.end_datetime
                    "
                  >
                    {{
                      errors.first("end_datetime") ||
                      serverSideErrors.end_datetime
                    }}
                  </span>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions class="pb-5">
            <v-btn
              color="secondary"
              dark
              class="px-8 ml-2"
              @click="saveEventDetail"
              :loading="loading"
              >Save</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { mapMutations } from "vuex";
import moment from "moment";
export default {
  data() {
    return {
      user: {},
      loading: false,
      serverSideErrors: {},
      event: {
        title: "",
        description: "",
        start_datetime: new Date(),
        end_datetime: new Date(),
        picture_url: "",
      },
      profile_pic: {},
      previewImage: null,
    };
  },
  watch: {
    "event.start_datetime" : function() {
      if(this.event.start_datetime && this.event.end_datetime) {
        let difference = moment(this.event.end_datetime,"DD-MM-YYYY hh:mm:ss A").diff(this.event.start_datetime,'minutes');
        if(difference < 0) {
          this.event.end_datetime = moment(this.event.start_datetime,"DD-MM-YYYY hh:mm:ss A").add('1','hour').format("DD-MM-YYYY hh:mm a");
        }
      }
    },
    "event.end_datetime" : function() {
      if(this.event.start_datetime && this.event.end_datetime) {
        let difference = moment(this.event.start_datetime,"DD-MM-YYYY hh:mm:ss A").diff(this.event.end_datetime,'minutes');
        if(difference > 0) {
          this.event.start_datetime = moment(this.event.end_datetime,"DD-MM-YYYY hh:mm:ss A").subtract('1','hour').format("DD-MM-YYYY hh:mm a");
        }
      }
    },
  },
  methods: {
    ...mapMutations("alert", ["setAlert"]),
    saveEventDetail() {
      let _self = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          _self.loading = true;
          let formData = new FormData();

          formData.append("title", this.event.title);
          formData.append("description", this.event.description);
          formData.append(
            "start_datetime",
            moment.utc(this.event.start_datetime).valueOf()
          );
          formData.append(
            "end_datetime",
            moment.utc(this.event.end_datetime).valueOf()
          );
          formData.append("picture", this.profile_pic);

          _self.$axios
            .put("/societyadmin/events/" + _self.$route.params.id, formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then((response) => {
              let data = response.data;

              _self.loading = false;
              _self.serverSideErrors = {};

              if (data.status) {
                this.setAlert({
                  showAlert: true,
                  message: data.message,
                  variant: "green accent-4",
                  timeout: 2000,
                });
                _self.$router.push({ path: "/societyadmin/event" });
              } else {
                if (!data.errors) {
                  this.setAlert({
                    showAlert: true,
                    message: data.message,
                    variant: "red accent-3",
                    timeout: 2000,
                  });
                } else {
                  for (let i = 0; i < data.errors.length; i++) {
                    this.serverSideErrors[data.errors[i].field] =
                      data.errors[i].message;
                  }
                }
              }
            });
        }
      });
    },
    getEventDetail() {
      let _self = this;
      _self.$axios
        .get("societyadmin/events/" + _self.$route.params.id)
        .then((response) => {
          let data = response.data;
          if (data.status) {
            data.event.start_datetime = new Date(data.event.start_datetime);
            data.event.end_datetime = new Date(data.event.end_datetime);
            _self.event = data.event;
          } else {
            if (data.errors) {
              _self.serverSideErrors = {};

              for (let i = 0; i < data.errors.length; i++) {
                _self.serverSideErrors[data.errors[i].field] =
                  data.errors[i].message;
              }
            } else {
              this.setAlert({
                showAlert: true,
                variant: "red accent-3",
                timeout: "2000",
                message: data.message,
              });
            }
          }
        });
    },
    openFileExplorer() {
      this.$refs.profile_pic.click();
    },
    changeFile(e) {
      this.profile_pic = e.target.files[0];
      let input = this.$refs.profile_pic;
      let file = input.files;
      if (file && file[0]) {
        let reader = new FileReader();
        reader.onload = (e) => {
          this.previewImage = e.target.result;
        };
        reader.readAsDataURL(file[0]);
        this.$emit("input", file[0]);
      }
    },
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.getEventDetail();
  },
};
</script>
<style scoped>
.font-30 {
  font-size: 30px !important;
}
/* make the icon clickable in badge slot */
.edit-icon {
  z-index: 1000;
}
.imagePreviewWrapper {
  width: 120px;
  height: 120px;
  display: block;
  cursor: pointer;
  margin: auto;
  background-size: cover;
  background-position: center center;
}
</style>